import React from "react";

import { formatPrice, stypes, renderNumberGreaterThan100 } from "../common/common";
import { IcStarRating, IcTotalTrip, IcAddrCar, IcInstant } from "../common/svg";

import avatar_default from "../../static/images/avatar_default.png";

const CarItemMap = ({ car, stype, appInit }) => {
	const isSD = stype === stypes.SD;
	const priceMode = appInit?.data?.priceMode;

	return (
		<div key={car.id} className="swiper-slide">
			<div className="item-car row">
				<div className="item-box">
					<div className="img-car">
						<div className="fix-img">
							<img
								loading="lazy"
								src={car.photos ? car.photos[0].thumbUrl : avatar_default}
								alt="Mioto - Thuê xe tự lái"
							/>
						</div>
						{/* <div className="fav-item wrap-svg">
							<svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M17.7083 7.26666C17.7083 8.23333 17.3417 9.20833 16.6 9.95L15.3667 11.1833L10.0583 16.4917C10.0333 16.5167 10.025 16.525 10 16.5417C9.97501 16.525 9.96667 16.5167 9.94167 16.4917L3.40001 9.95C2.65834 9.20833 2.29167 8.24166 2.29167 7.26666C2.29167 6.29166 2.65834 5.31667 3.40001 4.575C4.88334 3.1 7.28334 3.1 8.76667 4.575L9.99167 5.80833L11.225 4.575C12.7083 3.1 15.1 3.1 16.5833 4.575C17.3417 5.31667 17.7083 6.28333 17.7083 7.26666Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
							</svg>
						</div> */}
						{car.instant ? (
							<span className="label-pos">
								<span className="rent">
									Đặt xe nhanh
									<IcInstant />
								</span>
							</span>
						) : null}
					</div>
					<div className="desc-car">
						{/* <div className="desc-tag">
							<span className="tag-item transmission">{CarTransmission[car.optionsTransmission]}</span>

							{car.deliveryEnable === 1 ? (
								<span className="tag-item delivery">
									{car.deliveryPrice > 0 ? "Giao xe tận nơi" : "Miễn phí giao xe"}
								</span>
							) : null}
						</div> */}
						<div className="desc-name">
							<p>{car.name}</p>
						</div>
						<div className="desc-info">
							{car.totalTrips > 0 ? (
								<>
									<div className="wrap-svg">
										<IcStarRating />
									</div>
									<span className="info">{car.rating.avg.toFixed(1)}</span>
									<span className="dot">•</span>
									<div className="wrap-svg">
										<IcTotalTrip />
									</div>
									<span className="info">{renderNumberGreaterThan100(car.totalTrips)} chuyến</span>
								</>
							) : (
								<>
									<span className="info">Chưa có chuyến</span>
								</>
							)}
						</div>
						<div className="desc-address">
							<div className="wrap-svg">
								<IcAddrCar />
							</div>
							<p>{car.locationAddrS}</p>
						</div>
						<div className="desc-price">
							{isSD ? (
								priceMode === 2 ? (
									<div className="price">
										{car.priceOriginWithFee !== car.priceWithFee && (
											<span className="price-origin">{formatPrice(car.priceOriginWithFee)}</span>
										)}
										<span className="price-special">{formatPrice(car.priceWithFee)}</span>
										/&nbsp;ngày
									</div>
								) : (
									<div className="price">
										{car.priceOrigin !== car.price && (
											<span className="price-origin">{formatPrice(car.priceOrigin)}</span>
										)}
										<span className="price-special">{formatPrice(car.price)}</span>
										/&nbsp;ngày
									</div>
								)
							) : priceMode === 2 ? (
								<div className="price">
									{car.wdShort && car.wdShort.priceOriginWithFee !== car.wdShort.priceWithFee && (
										<span className="price-origin">{formatPrice(car.wdShort.priceOriginWithFee)}</span>
									)}
									<span className="price-special">{formatPrice(car.wdShort && car.wdShort.priceWithFee)}&nbsp;</span>
									/&nbsp;chuyến
								</div>
							) : (
								<div className="price">
									{car.wdShort && car.wdShort.priceOrigin !== car.wdShort.price && (
										<span className="price-origin">{formatPrice(car.wdShort.priceOrigin)}</span>
									)}
									<span className="price-special">{formatPrice(car.wdShort && car.wdShort.price)}&nbsp;</span>
									/&nbsp;chuyến
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CarItemMap;
